// example for exporting function
// export const brrt = () => { 
//     alert('brrt');
// }

import axios from 'axios';

const Cookies = () => {
}

export const isLoggedIn = async () => {
    const username = get_cookies('username');
  if(!username){
      //window.location.replace("/login");
      window.location.replace(process.env.REACT_APP_BASE_URL+"/login");
  }

  await axios
      .post(process.env.REACT_APP_API_URL + "check_status",{
        username:get_cookies('username'),
        branchidno:get_cookies('branchidno')
      })
      .then(function (res) {
        if(res.data.data.status == 0 ){
          delete_all_cookies();

          // Clear local storage and session storage (important!)
          localStorage.clear();
          sessionStorage.clear();

          // If you use Zustand or Redux, clear the user state too!
          // userStore.setState({ user: null }); // <-- if you have it

          // Navigate and replace history so user cannot go back
        window.location.replace(process.env.REACT_APP_BASE_URL+"/login");
        }
      })
      .catch(function (error) {
      console.log('error',error)
      });
  


}

export const add_cookies = (name, value, hours) =>{
    let expires;
    if (hours) {
        let date = new Date();
        date.setTime(date.getTime()+(hours*60*60*1000));
        expires = "; expires="+date.toGMTString();
    }
    else{
        expires = "";
    }
    //set cookie
    document.cookie = name+"="+value+expires+";";
    //console.log(name+"="+value+expires+";");
}

export const get_cookies = (name) => {
    var username = getCookie(name);
    //console.log(username);
    return username;
}
export const delete_all_cookies = () => {
  // Get all cookies as a string
  const cookies = document.cookie.split(';');

  // Loop through each cookie
  cookies.forEach(cookie => {
    const cookieName = cookie.split('=')[0].trim();
    document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    localStorage.clear();
    sessionStorage.clear();
  });
};

// export const delete_all_cookies = () => {
//   document.cookie = 'user_id=; expires=Thu, 01 Jan 1970 00:00:00 UTC;';
//   document.cookie = 'username=; expires=Thu, 01 Jan 1970 00:00:00 UTC;';
//   document.cookie = 'userrole=; expires=Thu, 01 Jan 1970 00:00:00 UTC;';
//   document.cookie = 'fullname=; expires=Thu, 01 Jan 1970 00:00:00 UTC;';
//   document.cookie = 'branchidno=; expires=Thu, 01 Jan 1970 00:00:00 UTC;';
//   document.cookie = 'main.nav.access=; expires=Thu, 01 Jan 1970 00:00:00 UTC;';
//   document.cookie = 'content.nav.access=; expires=Thu, 01 Jan 1970 00:00:00 UTC;';
//   document.cookie = 'position_id=; expires=Thu, 01 Jan 1970 00:00:00 UTC;';
//   document.cookie = 'curcode=; expires=Thu, 01 Jan 1970 00:00:00 UTC;';
// }



const getCookie = (name) => {
  // Add the = sign
  name = name + '=';

  // Get the decoded cookie
  var decodedCookie = decodeURIComponent(document.cookie);

  // Get all cookies, split on ; sign
  var cookies = decodedCookie.split(';');

  // Loop over the cookies
  for (var i = 0; i < cookies.length; i++) {
    // Define the single cookie, and remove whitespace
    var cookie = cookies[i].trim();

    // If this cookie has the name of what we are searching
    if (cookie.indexOf(name) === 0) {
      // Return everything after the cookies name
      return cookie.substring(name.length, cookie.length);
    }
  }
}
const moment = require('moment-timezone');

export const timeZoneChanger = (selectedDate = null) => {
  const country = get_cookies('country')?.toLowerCase();

  const countryTimezones = {
    philippines: "Asia/Manila",
    "united arab emirates": "Asia/Dubai",
    nigeria: "Africa/Lagos",
    taiwan: "Asia/Taipei",
    singapore: "Asia/Singapore",
    korea: "Asia/Seoul",
    oman: "Asia/Muscat",
    qatar: "Asia/Qatar",
    kuwait: "Asia/Kuwait",
    malaysia: "Asia/Kuala_Lumpur",
    italy: "Europe/Rome",
    spain: "Europe/Madrid",
    switzerland: "Europe/Zurich",
    "hong kong": "Asia/Hong_Kong",
    "united states": "America/Los_Angeles",
    canada: "America/Vancouver",
    australia: "Australia/Melbourne",
    japan: "Asia/Tokyo",
    uganda: "Africa/Kampala"
  };
  const timezone = countryTimezones[country] || "Asia/Manila";

  return moment().tz(timezone).format("MMM D YYYY"); 

};
export const time  = (setSelectedTime) =>{
  if (get_cookies('country') == "Philippines") {
    setSelectedTime(moment.tz(new Date(), "Asia/Dubai").format('h:mm a'));
    }else if(get_cookies('country')== "United Arab Emirates"){
      setSelectedTime(moment.tz(new Date(), "Asia/Dubai").format('h:mm a'));
    }else if(get_cookies('country')== "Nigeria"){
      setSelectedTime(moment.tz(new Date(), "Africa/Lagos").format('h:mm a'));
    }else if(get_cookies('country')== "Taiwan"){
      setSelectedTime(moment.tz(new Date(), "Asia/Taipei").format('h:mm a'));
    }else if(get_cookies('country')== "Singapore"){
      setSelectedTime(moment.tz(new Date(), "Asia/Singapore").format('h:mm a'));
    }else if(get_cookies('country')== "Korea"){
      setSelectedTime(moment.tz(new Date(), "Asia/Seoul").format('h:mm a'));
    }else if(get_cookies('country')== "Oman"){
      setSelectedTime(moment.tz(new Date(), "Asia/Muscat").format('h:mm a'));
    }else if(get_cookies('country')== "Europe"){
      setSelectedTime(moment.tz(new Date(), "Europe/Rome").format('h:mm a'));
    }else if(get_cookies('country')== "Hong Kong"){
      setSelectedTime(moment.tz(new Date(), "Asia/Hong_Kong").format('h:mm a'));
    }else if(get_cookies('country')== "Malaysia"){
      setSelectedTime(moment.tz(new Date(), "Asia/Kuala_Lumpur").format('h:mm a'));
    }
    else if(get_cookies('country')== "United States"){
      setSelectedTime(moment.tz(new Date(), "Us/Central").format('h:mm a'));
    }
    else if(get_cookies('country')== "Australia"){
      setSelectedTime(moment.tz(new Date(), "Australia/Melbourne").format('h:mm a'));
    }    else if(get_cookies('country')== "Uganda"){
      setSelectedTime(moment.tz(new Date(), "Africa/Kampala").format('h:mm a'));
    }    else if(get_cookies('country')== "Japan"){
      setSelectedTime(moment.tz(new Date(), "Asia/Tokyo").format('h:mm a'));
    }else{
      setSelectedTime(moment.tz(new Date(), "Asia/Manila").format('hh:mm a'));
    }
}


// export const timeZoneChange  = (setItem_order_data) =>{
//   if (get_cookies('country')== "DAVAOHQ") {
//     setItem_order_data({
//       manufacturing_date:moment.tz(new Date(), "Asia/Manila").format('MMM D, yyyy'),
//       expiration_date:moment.tz(new Date(), "Asia/Manila").format('MMM D, yyyy'),
//       batch_no: ""
//     });
//     }else if(get_cookies('country')== "DUBAIHQ"){
//       setItem_order_data({
//         manufacturing_date:moment.tz(new Date(), "Asia/Dubai").format('MMM D, yyyy'),
//         expiration_date:moment.tz(new Date(), "Asia/Dubai").format('MMM D, yyyy'),
//         batch_no: ""
//       });
//     }else if(get_cookies('country')== "NIGERIAHQ"){
//       setItem_order_data({
//         manufacturing_date:moment.tz(new Date(), "Africa/Lagos").format('MMM D, yyyy'),
//         expiration_date:moment.tz(new Date(), "Africa/Lagos").format('MMM D, yyyy'),
//         batch_no: ""
//       });
//     }else if(get_cookies('country')== "CEBUHQ"){
//       setItem_order_data({
//         manufacturing_date:moment.tz(new Date(), "Asia/Manila").format('MMM D, yyyy'),
//         expiration_date:moment.tz(new Date(), "Asia/Manila").format('MMM D, yyyy'),
//         batch_no: ""
//       });
//     }else if(get_cookies('country')== "QATARHQ"){
//       setItem_order_data({
//         manufacturing_date:moment.tz(new Date(), "Asia/Qatar").format('MMM D, yyyy'),
//         expiration_date:moment.tz(new Date(), "Asia/Qatar").format('MMM D, yyyy'),
//         batch_no: ""
//       });
//     }else if(get_cookies('country')== "SINGAPOREHQ"){
//       setItem_order_data({
//         manufacturing_date:moment.tz(new Date(), "Asia/Singapore").format('MMM D, yyyy'),
//         expiration_date:moment.tz(new Date(), "Asia/Singapore").format('MMM D, yyyy'),
//         batch_no: ""
//       });
//     }else if(get_cookies('country')== "KOREAHQ"){
//       setItem_order_data({
//         manufacturing_date:moment.tz(new Date(), "Asia/Seoul").format('MMM D, yyyy'),
//         expiration_date:moment.tz(new Date(), "Asia/Seoul").format('MMM D, yyyy'),
//         batch_no: ""
//       });
//     }else if(get_cookies('country')== "OMANHQ"){
//       setItem_order_data({
//         manufacturing_date:moment.tz(new Date(), "Asia/Muscat").format('MMM D, yyyy'),
//         expiration_date:moment.tz(new Date(), "Asia/Muscat").format('MMM D, yyyy'),
//         batch_no: ""
//       });
//     }else if(get_cookies('country')== "ITALYHQ"){
//       setItem_order_data({
//         manufacturing_date:moment.tz(new Date(), "Europe/Rome").format('MMM D, yyyy'),
//         expiration_date:moment.tz(new Date(), "Europe/Rome").format('MMM D, yyyy'),
//         batch_no: ""
//       });
//     }else if(get_cookies('country')== "ABUDHABIHQ"){
//       setItem_order_data({
//         manufacturing_date:moment.tz(new Date(), "Asia/Dubai").format('MMM D, yyyy'),
//         expiration_date:moment.tz(new Date(), "Asia/Dubai").format('MMM D, yyyy'),
//         batch_no: ""
//       });
//     }else if(get_cookies('country')== "KSAHQ"){
//       setItem_order_data({
//         manufacturing_date:moment.tz(new Date(), "Asia/Riyadh").format('MMM D, yyyy'),
//         expiration_date:moment.tz(new Date(), "Asia/Riyadh").format('MMM D, yyyy'),
//         batch_no: ""
//       });
//     }else if(get_cookies('country')== "HONGKONGHQ"){
//       setItem_order_data({
//         manufacturing_date:moment.tz(new Date(), "Asia/Hong_Kong").format('MMM D, yyyy'),
//         expiration_date:moment.tz(new Date(), "Asia/Hong_Kong").format('MMM D, yyyy'),
//         batch_no: ""
//       });
//     }else if(get_cookies('country')== "MALAYSIAHQ"){
//       setItem_order_data({
//         manufacturing_date:moment.tz(new Date(), "Asia/Kuala_Lumpur").format('MMM D, yyyy'),
//         expiration_date:moment.tz(new Date(), "Asia/Kuala_Lumpur").format('MMM D, yyyy'),
//         batch_no: ""
//       });
//     }else if(get_cookies('country')== "SPAINHQ"){
//       setItem_order_data({
//         manufacturing_date:moment.tz(new Date(), "Europe/Madrid").format('MMM D, yyyy'),
//         expiration_date:moment.tz(new Date(), "Europe/Madrid").format('MMM D, yyyy'),
//         batch_no: ""
//       });
//     }
//     else if(get_cookies('country')== "AUSTRALIAHQ"){
//       setItem_order_data({
//         manufacturing_date:moment.tz(new Date(), "Australia/Melbourne").format('MMM D, yyyy'),
//         expiration_date:moment.tz(new Date(), "Australia/Melbourne").format('MMM D, yyyy'),
//         batch_no: ""
//       });
//     }
//     else if(get_cookies('country')== "USAHQ"){
//       setItem_order_data({
//         manufacturing_date:moment.tz(new Date(), "Us/Central").format('MMM D, yyyy'),
//         expiration_date:moment.tz(new Date(), "Us/Central").format('MMM D, yyyy'),
//         batch_no: ""
//       });
//     }else{
//       setItem_order_data(moment.tz(new Date(), "Asia/Manila").format('MMM D YYYY'));
//     }
// }

export const timeChanger = (selectedDate = null) => {
  const country = get_cookies('country')?.toLowerCase();

  const countryTimezones = {
    philippines: "Asia/Manila",
    "united arab emirates": "Asia/Dubai",
    nigeria: "Africa/Lagos",
    taiwan: "Asia/Taipei",
    singapore: "Asia/Singapore",
    korea: "Asia/Seoul",
    oman: "Asia/Muscat",
    qatar: "Asia/Qatar",
    kuwait: "Asia/Kuwait",
    malaysia: "Asia/Kuala_Lumpur",
    italy: "Europe/Rome",
    spain: "Europe/Madrid",
    switzerland: "Europe/Zurich",
    "hong kong": "Asia/Hong_Kong",
    "united states": "America/Los_Angeles",
    canada: "America/Vancouver",
    australia: "Australia/Melbourne",
    japan: "Asia/Tokyo",
    uganda: "Africa/Kampala"
  };

  const timezone = countryTimezones[country] || "Asia/Manila";

  return moment(selectedDate || new Date())
    .tz(timezone)
    .format("HH:mm");
};

export const getUserCountry = async () => {
  // Try cookie first
  const cookieCountry = get_cookies("country");
  if (cookieCountry) return cookieCountry;

  try {
    const res = await fetch("https://ipapi.co/json/");
    const data = await res.json();
    return data.country_name || "Philippines"; // default if detection fails
  } catch (err) {
    console.error("Country detection failed:", err);
    return "Philippines"; // default
  }
};

export const timeZoneChangerWithTime = (selectedDate = null) => {
  const country = get_cookies('country')?.toLowerCase();

  const countryTimezones = {
    philippines: "Asia/Manila",
    "united arab emirates": "Asia/Dubai",
    nigeria: "Africa/Lagos",
    taiwan: "Asia/Taipei",
    singapore: "Asia/Singapore",
    korea: "Asia/Seoul",
    oman: "Asia/Muscat",
    qatar: "Asia/Qatar",
    kuwait: "Asia/Kuwait",
    malaysia: "Asia/Kuala_Lumpur",
    italy: "Europe/Rome",
    spain: "Europe/Madrid",
    switzerland: "Europe/Zurich",
    "hong kong": "Asia/Hong_Kong",
    "united states": "America/Los_Angeles",
    canada: "America/Vancouver",
    australia: "Australia/Melbourne",
    japan: "Asia/Tokyo",
    uganda: "Africa/Kampala"
  };
  const timezone = countryTimezones[country] || "Asia/Manila";

  return moment().tz(timezone).format("YYYY-MM-DD HH:mm"); 

};



export default Cookies;
